import '../admin-page/admin-page.css';
import { Header } from '../header/header';
import { Menu } from 'antd';
import { useState } from 'react';
import type { MenuProps } from 'antd';
import { QualifyingQuestionsComponent } from '../admin-page/components/qualifying-questions/qualifying-questions';
import { QualificationFlowsComponent } from '../admin-page/components/qualifying-flow/qualifying-flow';

type MenuItem = Required<MenuProps>['items'][number];

export const QualificationConfigPage = () => {
  const [selectedKey, setSelectedKey] = useState<string>('1');

  const items: MenuItem[] = [
    { key: 1, label: 'Qualifying Questions' },
    { key: 2, label: 'Qualification Flows' },
  ];

  return (
    <>
      <Header />
      <div className="flex-admin-container">
        <Menu defaultSelectedKeys={['1']} mode="inline" style={{ width: '11%' }} onSelect={(item) => setSelectedKey(item.key.toString())} items={items} />
        {selectedKey === '1' && <QualifyingQuestionsComponent />}
        {selectedKey === '2' && <QualificationFlowsComponent />}
      </div>
    </>
  );
};
